// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".flex-flow-col[data-v-8f246a7e]{flex-flow:column}.full-display[data-v-8f246a7e]{background:linear-gradient(#61c7f7,#009ce5)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
